import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import AiDisclaimer from '../AiDisclaimer/AiDisclaimer';
import './Layout.css';

interface LayoutProps {
  title: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ title, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout-root">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="layout-main">
        <Header title={title} onMenuClick={() => setSidebarOpen(v => !v)} />
        <main className="layout-content">{children}</main>
        <AiDisclaimer />
      </div>
    </div>
  );
};

export default Layout;
